import { ApiError, NetworkError, detailNumber } from "./error";

/**
 * Текст ошибки для оператора.
 *
 * В мини-аппе на этом месте политика из десяти веток: там ошибка меняет экран
 * (пополнение вместо тоста, блокировка вместо ретрая). В админке реакция одна
 * — сообщение, и разводить ветвление незачем. Отличаются только формулировки:
 * «конфликт статуса» и «нет прав» без пояснения оператор читает как поломку.
 *
 * 401 сюда не попадает: его перехватывает клиент и завершает сессию.
 */
export function errorMessage(error: unknown): string {
  if (error instanceof NetworkError) {
    return "Нет связи с сервером. Проверьте сеть и повторите.";
  }
  if (!(error instanceof ApiError)) {
    return error instanceof Error ? error.message : String(error);
  }

  switch (error.code) {
    case "FORBIDDEN":
      return "Недостаточно прав: действие доступно только суперадминистратору.";
    case "NOT_FOUND":
      return "Запись не найдена — возможно, её уже удалили или обработали.";
    case "CONFLICT":
      // Сообщение бэкенда здесь содержательно: «заявка уже обработана»,
      // «недопустимый переход из статуса», «за эту дату уже есть начисление».
      return error.message;
    case "TOO_MANY_REQUESTS": {
      const seconds = detailNumber(error.details, "retry_after");
      return seconds
        ? `Слишком часто. Повторите через ${String(seconds)} с.`
        : "Слишком часто. Повторите через минуту.";
    }
    case "VALIDATION_ERROR":
      return "Форма заполнена неверно — проверьте подсвеченные поля.";
    default:
      return error.status >= 500
        ? "Сервис недоступен. Повторите позже."
        : error.message;
  }
}
